<template>
  <div class="animated fadeIn dashboard-manager">
    <ScrollTop></ScrollTop>
    <SearchSession
      :onSearchText="onSearchText"
    ></SearchSession>
    <div class="client-card-container">
      <div class="isLoading" v-if="isLoading">
        <div class="spinner-align">
          <Icon name="spinner" scale="5" pulse class="icon-size"></Icon>
        </div>
      </div>
      <ClientCardsManagement 
        :clients="clients" 
        :listEM="listEM"
        v-if="!isLoading"
      >
      </ClientCardsManagement>
    </div>
    <div class="pagination-container">
      <p class="total-text">{{totalRows}} Clients</p>
      <b-pagination 
        v-model="currentPage" 
        :total-rows="totalRows" 
        :per-page="itemsPerPage"
        pills
        :first-number="true"
        :last-number="true"
        @change="onChangePagination"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import nav from '../../_nav';
import ScrollTop from '../../components/utils/ScrollTop';
import {
  ClientCardsManagement,
  SearchSession
} from '../../components/commons';
import {mapActions, mapMutations} from 'vuex';
import consts from '../../_consts';
import Icon from 'vue-awesome/components/Icon';
export default {
  name: 'manage-client-view',
  components: {
    ScrollTop,
    ClientCardsManagement,
    SearchSession,
    Icon
  },
  data () {
    return {
      nav: nav.managerNav,
      currentPage: 1,
      totalRows: 0,
      itemsPerPage: 10,
      clients: null,
      isLoading: false,
      searchString: '',
      listEM: []
    }
  },
  methods: {
    onChangePagination (page) {
      this.currentPage = page;
      this.onGetClientsPaging();
    },
    onSearchText (textSearch) {
      this.searchString = textSearch;
      this.currentPage = 1;
      this.onGetClientsPaging();
    },
    onGetClientsPaging () {
      this.isLoading = true;
      this.callApiGetClientsPaging({
        pageNum: this.currentPage - 1,
        pageSize: this.itemsPerPage,
        searchString: this.searchString
      }).then((response) => {
        this.totalRows = response.totalClients;
        this.clients = response.clients;
      }).finally(() => {
        this.isLoading = false;
      });
    },
    ...mapActions({
      getAllAM: 'ACTION_GET_LIST_AM',
      callApiGetClientsPaging: 'ACTION_GET_CLIENTS_PAGING',
      getListEM: 'ACTION_GET_LIST_EM'
    }),
    ...mapMutations({
      setManagerView: 'MUTATION_SET_MANAGER_VIEW'
    })
  },
  beforeMount () {
    this.onGetClientsPaging();
    this.$store.dispatch('ACTION_GET_EVENT_COUNT', true);
    this.getAllAM();
  },
  created () {
    this.getListEM().then(response => {
      this.listEM = response.userProfiles;
    })
    this.setManagerView(consts.viewNames.managerDashboard);
  }
};
</script>


// WEBPACK FOOTER //
// src/views/manager/DashboardManager.vue?1cb8caa0